<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" *ngIf="movementOrderDetails">
  <sc-dialog-title>{{'Rangierauftrag annehmen' |
    translate:['tmc-yard.widgets.movement-orders.moving-order-strategy-dialog.title',
    translationService.language]}}</sc-dialog-title>
  <sc-separator-line></sc-separator-line>

    <div class="hint" *ngIf="vehicleSelectionRequired">
      {{'Fahrzeug wählen' |
      translate:['tmc-yard.widgets.movement-orders.moving-order-strategy-dialog.select-vehicle',
      translationService.language]}}
    </div>

    <div class="hint" *ngIf="stationSelectionRequired">
      {{'Zielstation wählen' |
      translate:['tmc-yard.widgets.movement-orders.moving-order-strategy-dialog.select-target-station',
      translationService.language]}}
    </div>

    <sc-content-spacer vertical />

    <sc-flex-fitting-content [vertical]="true">

        <ng-container *ngIf="vehicleSelectionRequired">
          <sc-padding>
          <form [formGroup]="vehicleOptionsFormGroup">
            <mat-radio-group formControlName="vehicleSelectionMode">
              <mat-radio-button value="automatically">{{'automatically'
                |translate:
                ['tmc-yard.widgets.movement-orders.moving-order-strategy-dialog.vehicle-selection-mode.automatically',translationService.language]}}</mat-radio-button>
              <mat-radio-button value="manually">{{'manually' |
                translate:['tmc-yard.widgets.movement-orders.moving-order-strategy-dialog.vehicle-selection-mode.manually',translationService.language]}}</mat-radio-button>
            </mat-radio-group>
          </form>
          <app-moving-order-vehicle-selection *ngIf="vehicleSelectionMode === 'manually'"
            [vehicleStrategy]="movementOrderDetails.vehicleStrategy"
            (selectedVehicle)="selectedVehicleChanged($event)"></app-moving-order-vehicle-selection>
          <sc-content-spacer [grow]="true"></sc-content-spacer>
        </sc-padding>
        </ng-container>

        <ng-container *ngIf="stationSelectionRequired">
          <app-structure-selection [context]="structureSelectionContext"></app-structure-selection>
        </ng-container>
    </sc-flex-fitting-content>

    <sc-separator-line></sc-separator-line>

    <sc-padding>
    <sc-flex>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button (click)="cancelDialog()">{{'Cancel' |
        translate:['tmc-yard.widgets.sac-client.moving-order-dialog.action.cancel',
        translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button [disabled]="!confirmDialogEnabled" (click)="confirmDialog()">
        {{'Abruf erstellen' |
        translate:['tmc-yard.widgets.movement-orders.moving-order-strategy-dialog.action.create-movement-order',
        translationService.language]}}
      </button>
    </sc-flex>
  </sc-padding>
</sc-flex>
